import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SeoHead from "../components/SeoHead";

const proIncludes = [
  "Free for the first 30 days",
  "No credit card required to start",
  "Cancel anytime",
  "Reserved inbox names",
  "Ad-free experience",
  "Priority access",
  "Real-time inbox with automatic cleanup",
  "Private, account-linked addresses",
];

const developerIncludes = [
  "API access",
  "Webhook support",
  "Automated testing integrations",
  "Higher limits",
];

function Pricing() {
  return (
    <Layout>
      <SeoHead
        title="Pricing – Ghost Inbox Pro & Developer Plans"
        description="Simple, transparent pricing for Ghost Inbox. Pro plan includes reserved inbox names, ad-free experience, and priority access. Developer plan coming soon."
        path="/pricing"
      />

      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-wider text-emerald-400">Pricing</p>
          <h1 className="mt-2 text-3xl font-bold text-white md:text-4xl">
            Simple, transparent pricing
          </h1>
          <p className="mt-4 leading-relaxed text-zinc-400">
            Start with a full-featured free trial. Professional plans for teams who need reliable
            temporary inboxes for testing, QA, and privacy protection.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-2">
          <div className="relative rounded-2xl border border-emerald-500/30 bg-gradient-to-b from-zinc-900 to-zinc-950 p-8 shadow-lg shadow-emerald-900/10">
            <span className="inline-block rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-xs font-medium uppercase tracking-wider text-emerald-400">
              Pro
            </span>
            <h2 className="mt-4 text-2xl font-bold text-white">Ghost Inbox Pro</h2>
            <p className="mt-2 text-sm text-zinc-400">
              Everything you need for a secure, ad-free temporary inbox with reserved names and
              priority access.
            </p>
            <p className="mt-4 flex items-baseline gap-1">
              <span className="text-4xl font-bold text-white">$4.99</span>
              <span className="text-sm text-zinc-500">/ month</span>
            </p>

            <p className="mt-6 text-xs font-semibold uppercase tracking-wider text-zinc-500">
              Includes
            </p>
            <ul className="mt-3 space-y-3 text-sm text-zinc-300">
              {proIncludes.map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="mt-0.5 text-emerald-400" aria-hidden="true">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <Link
              to="/signup"
              className="mt-8 block w-full rounded-lg bg-emerald-500 py-3 text-center text-sm font-semibold text-zinc-950 transition hover:bg-emerald-400"
            >
              Get started
            </Link>
            <p className="mt-3 text-center text-xs text-zinc-500">
              No credit/debit card required for free account
            </p>
          </div>

          <div className="relative rounded-2xl border border-zinc-800 bg-zinc-900/40 p-8">
            <span className="inline-block rounded-full border border-zinc-700 bg-zinc-800/80 px-3 py-1 text-xs font-medium uppercase tracking-wider text-zinc-400">
              Coming soon
            </span>
            <h2 className="mt-4 text-2xl font-bold text-white">Developer Plan</h2>
            <p className="mt-2 text-sm text-zinc-400">
              Built for engineering teams who need programmatic access and higher throughput for
              automated testing pipelines.
            </p>
            <p className="mt-4 text-sm font-medium text-zinc-500">Pricing to be announced</p>

            <p className="mt-6 text-xs font-semibold uppercase tracking-wider text-zinc-500">
              Planned includes
            </p>
            <ul className="mt-3 space-y-3 text-sm text-zinc-400">
              {developerIncludes.map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="mt-0.5 text-zinc-500" aria-hidden="true">
                    ○
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <Link
              to="/contact"
              className="mt-8 block w-full rounded-lg border border-zinc-700 py-3 text-center text-sm font-medium text-zinc-300 transition hover:border-zinc-500 hover:text-white"
            >
              Contact Us
            </Link>
            <p className="mt-3 text-center text-xs text-zinc-500">
              Interested in early access? Get in touch.
            </p>
          </div>
        </div>

        <p className="mt-10 text-center text-sm text-zinc-500">
          All plans are subject to our{" "}
          <Link to="/terms" className="text-emerald-400 hover:underline">
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link to="/acceptable-use" className="text-emerald-400 hover:underline">
            Acceptable Use Policy
          </Link>
          .
        </p>
      </div>
    </Layout>
  );
}

export default Pricing;
